import SurveyInsights from "../insights/SurveyInsights";

function SurveysInsightsTab() {
    return <SurveyInsights/>;
}

export default SurveysInsightsTab;
